import { Redirect } from "react-router-dom"
import { useState, useEffect } from 'react';

export default function ProtectedRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_AUTH_URL}/api/auth/session`, {
          credentials: 'include' 
        });
        const session = await response.json();
        if (session?.user) {
          setUser(session.user);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Session check failed:', error);
        setUser(null);
      } finally {
        setLoading(false);
      } 
    };

    checkSession();
  }, []);

  if (loading) return null  // wait for fetch to complete

  if (!user) return <Redirect to="/" />

  return children
}